import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import BlogsPortalListings from "../../component/Blogs & Landing Page/BlogsPortalListings";
import HeroBanner from "../../component/Common Banner Component/HeroBanner";

const BlogsScreen = () => {
  return (
    <Fragment>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      {/* <h1 style={{ color: "black" }} className="h1_main ps-5 pt-5 pb-5">
        Blogs Listing
      </h1> */}
      <HeroBanner
          Heading="Blogs Listing"
          Paragraph={"The Tru Life Wellness Blog Portal"}
          bgImg={"/images/creatives/plane-hero-bg.png"}
          sideLinks={false}
      />
      <BlogsPortalListings />
    </Fragment>
  );
};

export default BlogsScreen;
